module.exports = __webpack_public_path__ + "static/media/burger.60b7794e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/burger.jpg
// module id = 337
// module chunks = 0